export const categories = [
  { id: 1, name: '全部', slug: 'all', icon: 'ri-fire-line' },
  { id: 2, name: '明星黑料', slug: 'celebrity', icon: 'ri-star-line' },
  { id: 3, name: '网红内幕', slug: 'influencer', icon: 'ri-live-line' },
  { id: 4, name: '大V爆料', slug: 'kol', icon: 'ri-verified-badge-line' },
  { id: 5, name: '社会热点', slug: 'society', icon: 'ri-global-line' },
  { id: 6, name: '娱乐圈', slug: 'entertainment', icon: 'ri-movie-line' },
];

export const articles = [
  {
    id: 1,
    title: '顶流男星深夜私会神秘女子，酒店共度8小时全程曝光',
    slug: 'top-star-secret-date-exposed',
    excerpt: '据知情人士透露，某当红顶流男星近日被拍到深夜与一名神秘女子进入某五星级酒店，两人在房间内逗留长达8小时，次日清晨才先后离开。',
    content: `据知情人士透露，某当红顶流男星近日被拍到深夜与一名神秘女子进入某五星级酒店，两人在房间内逗留长达8小时，次日清晨才先后离开。

消息人士称，该男星近期正处于事业上升期，有多部大制作影视作品即将上映。其团队一直以"单身人设"进行营销推广，此次事件若属实，将对其商业价值产生重大影响。

当晚约23:30，该男星驾驶一辆黑色奔驰轿车抵达酒店地下停车场。约5分钟后，一名身穿黑色连衣裙的神秘女子从同一辆车中下来，两人刻意保持距离，先后进入酒店电梯。

次日早晨7:45左右，该女子率先从酒店大堂离开，随后男星也于8:10左右驾车离开。全程两人均佩戴口罩和帽子，显得极为谨慎。

目前该男星工作室尚未对此事作出回应。有网友发现，该男星近期在社交媒体上的互动频率明显下降，疑似正在处理此次公关危机。`,
    category: 'celebrity',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20night%20scene%20of%20a%20luxury%20five-star%20hotel%20entrance%20with%20moody%20atmospheric%20lighting%2C%20dark%20tones%2C%20paparazzi-style%20photography%20aesthetic%2C%20urban%20night%20background%20with%20city%20lights%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%20style%20with%20warm%20amber%20street%20lights%20against%20deep%20shadows&width=600&height=400&seq=article-card-1&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20night%20scene%20of%20a%20luxury%20five-star%20hotel%20entrance%20with%20moody%20atmospheric%20lighting%2C%20dark%20tones%2C%20paparazzi-style%20photography%20aesthetic%2C%20urban%20night%20background%20with%20city%20lights%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%20style%20with%20warm%20amber%20street%20lights%20against%20deep%20shadows&width=800&height=450&seq=hero-side-1&orientation=landscape',
    date: '2026-08-06',
    views: 128930,
    tags: ['顶流男星', '酒店私会', '恋情曝光', '人设崩塌'],
    isHot: true,
    isTop: true,
  },
  {
    id: 2,
    title: '千万粉丝女主播被曝私下辱骂粉丝，录音流出引众怒',
    slug: 'million-follower-streamer-insults-fans',
    excerpt: '一段疑似某千万粉丝级女主播的私下录音近日在网上疯传，录音中该主播用极其恶劣的语言辱骂粉丝，引发全网哗然。',
    content: `一段疑似某千万粉丝级女主播的私下录音近日在网上疯传，录音中该主播用极其恶劣的语言辱骂粉丝，引发全网哗然。

录音时长约3分钟，内容为该女主播与经纪人私下交谈时的对话。在对话中，该主播多次使用侮辱性词汇形容其粉丝群体，并嘲讽粉丝"人傻钱多"、"随便说几句好话就疯狂打赏"。

录音曝光后，大量粉丝在社交平台表达愤怒和失望。该主播的粉丝数量在24小时内暴跌超过200万，多个品牌方也紧急宣布与其解除合作。

业内人士分析称，此次事件对该主播的商业价值造成了毁灭性打击，预计损失将超过5000万元。目前该主播的所有社交账号已设为私密状态。

多位直播行业从业者表示，这起事件为整个行业敲响了警钟，主播与粉丝之间的关系需要更加真诚和透明。`,
    category: 'influencer',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20streaming%20room%20with%20professional%20lighting%20equipment%20and%20a%20large%20monitor%20showing%20a%20live%20chat%20interface%2C%20mysterious%20shadowy%20atmosphere%2C%20moody%20cool%20tones%20with%20subtle%20warm%20accents%2C%20contemporary%20digital%20culture%20photography%2C%20editorial%20composition%20with%20negative%20space%2C%20cinematic%20noir%20style&width=600&height=400&seq=article-card-2&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20streaming%20room%20with%20professional%20lighting%20equipment%20and%20a%20large%20monitor%20showing%20a%20live%20chat%20interface%2C%20mysterious%20shadowy%20atmosphere%2C%20moody%20cool%20tones%20with%20subtle%20warm%20accents%2C%20contemporary%20digital%20culture%20photography%2C%20editorial%20composition%20with%20negative%20space%2C%20cinematic%20noir%20style&width=800&height=450&seq=hero-side-2&orientation=landscape',
    date: '2026-08-05',
    views: 95620,
    tags: ['女主播', '辱骂粉丝', '录音曝光', '人设崩塌', '品牌解约'],
    isHot: true,
    isTop: false,
  },
  {
    id: 3,
    title: '知名财经大V涉嫌虚假宣传，粉丝跟投亏损上亿',
    slug: 'finance-kol-false-promotion',
    excerpt: '拥有500万粉丝的知名财经大V被曝长期发布虚假投资收益截图，诱导粉丝跟投高风险项目，导致众多粉丝血本无归。',
    content: `拥有500万粉丝的知名财经大V被曝长期发布虚假投资收益截图，诱导粉丝跟投高风险项目，导致众多粉丝血本无归。

据受害者联合维权群统计，至少有超过3000名粉丝在该大V的引导下投入资金，总金额过亿。这些粉丝中不乏退休老人和在校大学生，有人甚至借高利贷进行投资。

调查发现，该大V长期在社交平台晒出超高收益截图，并声称自己有"内部消息"和"独家渠道"。然而经专业人士分析，这些截图均存在PS痕迹，所谓的"内部消息"完全是子虚乌有。

目前已有受害者向公安机关报案，相关部门已介入调查。该大V的所有社交账号已被平台封禁处理。

法律专家指出，此类行为已涉嫌构成诈骗罪。若罪名成立，该大V可能面临十年以上有期徒刑。同时也提醒广大网民，投资理财需谨慎，切勿轻信网络大V的推荐。`,
    category: 'kol',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20professional%20office%20desk%20with%20scattered%20financial%20documents%20and%20a%20laptop%20displaying%20stock%20charts%20with%20declining%20red%20arrows%2C%20dramatic%20lighting%20with%20shadows%2C%20serious%20business%20atmosphere%2C%20dark%20wood%20desk%20surface%2C%20editorial%20photography%20with%20warm%20tungsten%20light%20and%20deep%20contrast%2C%20moody%20corporate%20aesthetic&width=600&height=400&seq=article-card-3&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20professional%20office%20desk%20with%20scattered%20financial%20documents%20and%20a%20laptop%20displaying%20stock%20charts%20with%20declining%20red%20arrows%2C%20dramatic%20lighting%20with%20shadows%2C%20serious%20business%20atmosphere%2C%20dark%20wood%20desk%20surface%2C%20editorial%20photography%20with%20warm%20tungsten%20light%20and%20deep%20contrast%2C%20moody%20corporate%20aesthetic&width=800&height=450&seq=hero-side-3&orientation=landscape',
    date: '2026-08-04',
    views: 78230,
    tags: ['财经大V', '虚假宣传', '投资亏损', '诈骗'],
    isHot: true,
    isTop: false,
  },
  {
    id: 4,
    title: '某知名综艺节目录制现场爆发激烈冲突，导演被紧急送医',
    slug: 'variety-show-fight-hospital',
    excerpt: '据现场工作人员爆料，某卫视知名综艺节目在最新一期录制过程中，两位常驻嘉宾因节目环节设计问题爆发激烈肢体冲突。',
    content: `据现场工作人员爆料，某卫视知名综艺节目在最新一期录制过程中，两位常驻嘉宾因节目环节设计问题爆发激烈肢体冲突，导演上前劝阻时被误伤，当场倒地不起，被紧急送往医院。

知情人士透露，事发时节目正在进行一个竞技类游戏环节。两位嘉宾因对游戏规则理解不同产生口角，随后矛盾迅速升级。其中一位嘉宾突然情绪失控，抄起身边的道具砸向对方，另一位嘉宾也不甘示弱进行还击。

现场一度陷入混乱，工作人员纷纷上前拉架。导演在试图分开两人时，被飞来的道具击中头部，当场倒地。节目录制被迫中断。

医院方面表示，导演头部受到轻微震荡，目前已无大碍，但仍需留院观察。节目组发布声明称，将对此次事件进行全面调查，涉事嘉宾已暂停所有录制工作。

这起事件引发了业内对综艺节目安全管理的广泛讨论。多名业内人士呼吁，节目制作应更加注重嘉宾的身心健康，避免过度追求节目效果。`,
    category: 'entertainment',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20professional%20cameras%20and%20lighting%20rigs%20in%20disarray%2C%20scattered%20equipment%20on%20the%20floor%2C%20dramatic%20emergency%20atmosphere%20with%20red%20warning%20lights%2C%20behind-the-scenes%20chaos%20captured%20in%20editorial%20photography%20style%2C%20high%20contrast%20lighting%20with%20deep%20shadows%20and%20urgent%20mood&width=600&height=400&seq=article-card-4&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20television%20studio%20set%20with%20professional%20cameras%20and%20lighting%20rigs%20in%20disarray%2C%20scattered%20equipment%20on%20the%20floor%2C%20dramatic%20emergency%20atmosphere%20with%20red%20warning%20lights%2C%20behind-the-scenes%20chaos%20captured%20in%20editorial%20photography%20style%2C%20high%20contrast%20lighting%20with%20deep%20shadows%20and%20urgent%20mood&width=800&height=450&seq=hero-side-4&orientation=landscape',
    date: '2026-08-06',
    views: 112450,
    tags: ['综艺节目', '嘉宾冲突', '导演受伤', '录制事故'],
    isHot: true,
    isTop: false,
  },
  {
    id: 5,
    title: '知名女星离婚内幕曝光：丈夫出轨闺蜜，财产转移早有预谋',
    slug: 'actress-divorce-scandal-details',
    excerpt: '持续一个月的某知名女星离婚案终于水落石出，多方证据显示其丈夫不仅出轨其闺蜜，更在婚姻期间暗中转移大量夫妻共同财产。',
    content: `持续一个月的某知名女星离婚案终于水落石出，多方证据显示其丈夫不仅出轨其闺蜜，更在婚姻期间暗中转移大量夫妻共同财产。

据女星代理律师透露，在调查过程中发现了大量惊人内幕。其丈夫在婚姻存续期间，通过开设境外账户、虚假投资等方式，将超过2亿元的夫妻共同财产转移至海外。

更令人震惊的是，出轨对象竟然是女星相识十年的闺蜜。两人早在三年前就已开始秘密交往，期间该闺蜜仍频繁出现在女星的社交场合，表现得亲密无间。

女星在社交平台发布长文，表示"曾经最信任的两个人，给了我人生最痛的背叛"，引发全网共鸣。该文发布后迅速登上热搜，阅读量突破5亿。

目前法院已冻结了相关涉案资产，案件仍在进一步审理中。法律专家表示，恶意转移夫妻共同财产的行为可能影响财产分割结果。`,
    category: 'celebrity',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20elegant%20woman%20silhouette%20standing%20by%20a%20rain-streaked%20window%20in%20a%20luxury%20apartment%2C%20moody%20and%20melancholic%20atmosphere%2C%20soft%20natural%20light%20through%20cloudy%20skies%2C%20cinematic%20composition%20with%20emotional%20depth%2C%20editorial%20fashion%20photography%2C%20muted%20warm%20tones%20with%20cool%20shadows%2C%20introspective%20mood&width=600&height=400&seq=article-card-5&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=An%20elegant%20woman%20silhouette%20standing%20by%20a%20rain-streaked%20window%20in%20a%20luxury%20apartment%2C%20moody%20and%20melancholic%20atmosphere%2C%20soft%20natural%20light%20through%20cloudy%20skies%2C%20cinematic%20composition%20with%20emotional%20depth%2C%20editorial%20fashion%20photography%2C%20muted%20warm%20tones%20with%20cool%20shadows%2C%20introspective%20mood&width=800&height=450&seq=hero-side-5&orientation=landscape',
    date: '2026-08-03',
    views: 89720,
    tags: ['女星离婚', '出轨闺蜜', '财产转移', '婚姻内幕'],
    isHot: false,
    isTop: false,
  },
  {
    id: 6,
    title: '知名美食博主被曝后厨卫生堪忧，食材过期仍在使用',
    slug: 'food-blogger-hygiene-scandal',
    excerpt: '一位拥有800万粉丝的美食博主被前员工实名举报，其经营的线下餐厅后厨卫生条件极差，大量过期食材仍被用于制作菜品。',
    content: `一位拥有800万粉丝的美食博主被前员工实名举报，其经营的线下餐厅后厨卫生条件极差，大量过期食材仍被用于制作菜品。

举报人提供了大量照片和视频证据，显示后厨地面污水横流、蟑螂老鼠出没、食材随意堆放且无任何日期标识。视频中可以看到，工作人员将明显变质的肉类经过重口味调料处理后端上餐桌。

该博主在视频中一直以"精选优质食材"、"严格品控"为主要卖点，吸引了大量粉丝前往消费。餐厅人均消费高达500元以上，预约排期常常需要提前一个月。

事件曝光后，市场监管部门已对该餐厅进行突击检查，发现多项严重违规，目前已责令停业整顿。该博主的所有社交平台账号已被限制功能。

消费者权益保护组织表示，将协助受影响的消费者进行维权。同时提醒消费者，网络推荐仅作参考，消费前需理性判断。`,
    category: 'influencer',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20dirty%20commercial%20kitchen%20interior%20with%20greasy%20surfaces%20and%20neglected%20equipment%2C%20stark%20documentary%20photography%20style%2C%20harsh%20fluorescent%20lighting%20creating%20deep%20shadows%2C%20gritty%20realistic%20atmosphere%2C%20industrial%20kitchen%20setting%20with%20stainless%20steel%20surfaces%20reflecting%20dim%20light%2C%20investigative%20journalism%20aesthetic&width=600&height=400&seq=article-card-6&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20dirty%20commercial%20kitchen%20interior%20with%20greasy%20surfaces%20and%20neglected%20equipment%2C%20stark%20documentary%20photography%20style%2C%20harsh%20fluorescent%20lighting%20creating%20deep%20shadows%2C%20gritty%20realistic%20atmosphere%2C%20industrial%20kitchen%20setting%20with%20stainless%20steel%20surfaces%20reflecting%20dim%20light%2C%20investigative%20journalism%20aesthetic&width=800&height=450&seq=hero-side-6&orientation=landscape',
    date: '2026-08-02',
    views: 67340,
    tags: ['美食博主', '卫生问题', '后厨曝光', '食品安全'],
    isHot: false,
    isTop: false,
  },
  {
    id: 7,
    title: '某知识付费大V课程内容涉嫌抄袭，原作者发律师函维权',
    slug: 'knowledge-kol-plagiarism',
    excerpt: '近日，一位原创作者公开发声称，某知名知识付费大V售价2999元的爆款课程内容大量抄袭其已出版著作，已委托律师发函。',
    content: `近日，一位原创作者公开发声称，某知名知识付费大V售价2999元的爆款课程内容大量抄袭其已出版著作，已委托律师发函。

经对比发现，该大V课程中超过40%的内容与原作者的著作高度相似，部分段落甚至连错别字都完全一致。然而该大V从未在任何场合提及原作者或标明引用来源。

该课程自上线以来，已售出超过2万份，销售额突破6000万元。如果抄袭指控成立，这将是知识付费领域金额最大的侵权案件之一。

原作者表示，自己耗时三年完成的著作被如此轻易地剽窃，感到非常愤怒。"这不只是钱的问题，这是对知识创作者最基本的尊重问题。"

该大V发布简短声明否认抄袭，称"知识本就有相通之处"，但未提供有利证据。目前多个知识付费平台已将该课程下架处理。`,
    category: 'kol',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20study%20room%20with%20books%20scattered%20on%20a%20wooden%20desk%20next%20to%20a%20laptop%2C%20intellectual%20atmosphere%20with%20dramatic%20side%20lighting%20creating%20strong%20shadows%2C%20academic%20photography%20style%2C%20warm%20desk%20lamp%20glow%20against%20dark%20room%20background%2C%20contemplative%20and%20serious%20mood%2C%20shallow%20depth%20of%20field&width=600&height=400&seq=article-card-7&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20study%20room%20with%20books%20scattered%20on%20a%20wooden%20desk%20next%20to%20a%20laptop%2C%20intellectual%20atmosphere%20with%20dramatic%20side%20lighting%20creating%20strong%20shadows%2C%20academic%20photography%20style%2C%20warm%20desk%20lamp%20glow%20against%20dark%20room%20background%2C%20contemplative%20and%20serious%20mood%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=hero-side-7&orientation=landscape',
    date: '2026-08-01',
    views: 45210,
    tags: ['知识付费', '课程抄袭', '版权侵权', '律师函'],
    isHot: false,
    isTop: false,
  },
  {
    id: 8,
    title: '某选秀节目暗箱操作曝光：晋级名单早已内定',
    slug: 'talent-show-rigging-exposed',
    excerpt: '一位自称某选秀节目前工作人员的网友发布长文，详细揭露了节目组如何操纵投票系统、内定晋级名单的全过程。',
    content: `一位自称某选秀节目前工作人员的网友发布长文，详细揭露了节目组如何操纵投票系统、内定晋级名单的全过程。

据该爆料人透露，节目组在录制前就已经确定了最终的晋级名单。所谓的"观众投票"完全是走过场，后台系统可以随时修改票数。那些被淘汰的选手，只是因为不符合节目组预设的"人设"需求。

文中还披露了节目组如何通过剪辑手法制造话题和争议。比如刻意放大某些选手的失误，或者将正常的对话剪辑成"互怼"的效果，以此博取收视率。

该爆料称，某位最终夺冠的选手，其经纪公司早在节目开播前就与节目组签订了合作协议，支付了高达千万的"保送费"。

此文一出，迅速引发网友热议。多位曾参加过该节目的选手也纷纷发声，证实了爆料内容的真实性。相关部门表示将对选秀节目的公平性展开专项调查。`,
    category: 'entertainment',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20backstage%20view%20of%20a%20talent%20show%20stage%20seen%20from%20behind%20the%20curtains%2C%20theatrical%20lighting%20with%20deep%20blue%20and%20warm%20spotlight%20contrast%2C%20mysterious%20and%20conspiratorial%20atmosphere%2C%20editorial%20photography%20with%20cinematic%20composition%2C%20show%20business%20behind-the-scenes%20aesthetic%20with%20shadows%20and%20silhouettes&width=600&height=400&seq=article-card-8&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20backstage%20view%20of%20a%20talent%20show%20stage%20seen%20from%20behind%20the%20curtains%2C%20theatrical%20lighting%20with%20deep%20blue%20and%20warm%20spotlight%20contrast%2C%20mysterious%20and%20conspiratorial%20atmosphere%2C%20editorial%20photography%20with%20cinematic%20composition%2C%20show%20business%20behind-the-scenes%20aesthetic%20with%20shadows%20and%20silhouettes&width=800&height=450&seq=hero-side-8&orientation=landscape',
    date: '2026-07-31',
    views: 89450,
    tags: ['选秀节目', '暗箱操作', '投票造假', '内定'],
    isHot: false,
    isTop: false,
  },
  {
    id: 9,
    title: '网红奶茶店加盟骗局被曝光：千名加盟商血本无归',
    slug: 'bubble-tea-franchise-scam',
    excerpt: '一家由某知名网红代言的奶茶品牌被曝涉嫌加盟欺诈，全国超过1000名加盟商投入巨额加盟费后，总部却人去楼空。',
    content: `一家由某知名网红代言的奶茶品牌被曝涉嫌加盟欺诈，全国超过1000名加盟商投入巨额加盟费后，总部却人去楼空。

据受害者反映，该品牌通过网红代言和精心包装的招商广告，营造出"日赚万元"的虚假繁荣景象。加盟费从30万到80万不等，加上装修、设备、首批物料等费用，平均每家店投入超过100万元。

然而开店后，加盟商们发现总部承诺的"全程扶持"完全是一纸空文。所谓的"独家配方"不过是市面上随处可见的普通原料，而总部供应的物料价格远超市场价的3-5倍。

更恶劣的是，当加盟商们发现上当想要维权时，总部已经人去楼空，公司法人也已失联。警方已介入调查，初步认定这是一起有组织的加盟诈骗案。

该代言网红在事件曝光后发布道歉声明，称自己"也是受害者"，但网友们并不买账。多个消费者权益组织呼吁，应加强网红代言的法律责任。`,
    category: 'society',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20abandoned%20commercial%20storefront%20with%20a%20faded%20bubble%20tea%20shop%20sign%2C%20dusty%20interior%20visible%20through%20glass%20windows%2C%20urban%20decay%20photography%20style%2C%20overcast%20daylight%20creating%20flat%20melancholic%20lighting%2C%20contemporary%20Chinese%20street%20scene%2C%20documentary%20aesthetic%20with%20social%20commentary%20feel&width=600&height=400&seq=article-card-9&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=An%20abandoned%20commercial%20storefront%20with%20a%20faded%20bubble%20tea%20shop%20sign%2C%20dusty%20interior%20visible%20through%20glass%20windows%2C%20urban%20decay%20photography%20style%2C%20overcast%20daylight%20creating%20flat%20melancholic%20lighting%2C%20contemporary%20Chinese%20street%20scene%2C%20documentary%20aesthetic%20with%20social%20commentary%20feel&width=800&height=450&seq=hero-side-9&orientation=landscape',
    date: '2026-07-30',
    views: 123890,
    tags: ['网红奶茶', '加盟骗局', '血本无归', '代言责任'],
    isHot: false,
    isTop: false,
  },
  {
    id: 10,
    title: '知名歌手被曝偷税漏税数千万，工作室发声明否认',
    slug: 'singer-tax-evasion-allegations',
    excerpt: '据税务部门内部人士透露，某知名歌手因涉嫌偷逃税款正在接受调查，涉及金额或达数千万元。该歌手工作室火速发声明否认。',
    content: `据税务部门内部人士透露，某知名歌手因涉嫌偷逃税款正在接受调查，涉及金额或达数千万元。该歌手工作室火速发声明否认。

消息称，该歌手通过设立多家空壳公司、签订阴阳合同等方式，在2019年至2025年间累计偷逃个人所得税及增值税共计约4800万元。目前税务机关已完成初步调查，近期或将公布处理结果。

该歌手工作室在事发后两小时内即发布声明，称"一切经营行为均合法合规，网传消息不实"，并表示将追究造谣者法律责任。但声明中并未正面回应阴阳合同和空壳公司的问题。

业内人士分析，近年来税务部门对娱乐圈的税收监管力度持续加强，已有多位艺人因税务问题受到处罚。若此次指控属实，该歌手将面临巨额罚款和补缴税款。

网友对此事看法两极分化，有支持歌手的粉丝认为"又是黑粉造谣"，也有理性网友认为"声明太官方了，不如直接晒纳税记录"。`,
    category: 'celebrity',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20modern%20office%20with%20floor-to-ceiling%20windows%20overlooking%20a%20city%20skyline%2C%20desk%20with%20financial%20documents%20and%20a%20golden%20pen%2C%20dramatic%20contrast%20between%20warm%20interior%20lighting%20and%20cool%20exterior%20city%20lights%2C%20corporate%20photography%20style%2C%20sophisticated%20atmosphere%20with%20subtle%20tension%2C%20high-end%20business%20aesthetic&width=600&height=400&seq=article-card-10&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20modern%20office%20with%20floor-to-ceiling%20windows%20overlooking%20a%20city%20skyline%2C%20desk%20with%20financial%20documents%20and%20a%20golden%20pen%2C%20dramatic%20contrast%20between%20warm%20interior%20lighting%20and%20cool%20exterior%20city%20lights%2C%20corporate%20photography%20style%2C%20sophisticated%20atmosphere%20with%20subtle%20tension%2C%20high-end%20business%20aesthetic&width=800&height=450&seq=hero-side-10&orientation=landscape',
    date: '2026-07-28',
    views: 156730,
    tags: ['偷税漏税', '阴阳合同', '空壳公司', '税务调查'],
    isHot: false,
    isTop: false,
  },
  {
    id: 11,
    title: '直播带货翻车：知名主播售卖假黄金，消费者集体维权',
    slug: 'livestream-fake-gold-scandal',
    excerpt: '某头部直播带货主播被曝在直播间售卖的"足金首饰"经检测为镀金产品，实际含金量不足0.1%，涉及消费者超过5万人。',
    content: `某头部直播带货主播被曝在直播间售卖的"足金首饰"经检测为镀金产品，实际含金量不足0.1%，涉及消费者超过5万人。

事件起源于一位消费者购买后产生怀疑，将产品送往专业检测机构。检测结果显示，所谓的"999足金"实际上是铜镀金，黄金含量微乎其微。该消费者将检测报告发布到网上后，迅速引发连锁反应。

更多消费者纷纷将购买的产品送检，结果惊人的一致，全部为镀金产品。按当时的销售价格计算，该场直播的销售额超过3000万元，实际成本可能不到50万元。

涉事主播在舆论压力下发布道歉视频，称自己被供应商欺骗，"也是受害者"。但当网友要求其公开供应商信息时，该主播以"商业机密"为由拒绝。

消费者协会已介入此事，表示将协助消费者进行集体诉讼。平台方也已冻结该主播的所有收益，等待调查结果。`,
    category: 'influencer',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20close-up%20of%20fake%20gold%20jewelry%20on%20a%20dark%20velvet%20surface%20under%20a%20jewelry%20inspection%20lamp%2C%20revealing%20the%20cheap%20material%20underneath%20the%20gold%20coating%2C%20forensic%20photography%20style%2C%20stark%20lighting%20exposing%20imperfections%2C%20documentary%20evidence%20aesthetic%2C%20high%20detail%20macro%20shot%20with%20clinical%20precision&width=600&height=400&seq=article-card-11&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20close-up%20of%20fake%20gold%20jewelry%20on%20a%20dark%20velvet%20surface%20under%20a%20jewelry%20inspection%20lamp%2C%20revealing%20the%20cheap%20material%20underneath%20the%20gold%20coating%2C%20forensic%20photography%20style%2C%20stark%20lighting%20exposing%20imperfections%2C%20documentary%20evidence%20aesthetic%2C%20high%20detail%20macro%20shot%20with%20clinical%20precision&width=800&height=450&seq=hero-side-11&orientation=landscape',
    date: '2026-07-27',
    views: 98760,
    tags: ['直播带货', '假黄金', '集体维权', '消费者权益'],
    isHot: false,
    isTop: false,
  },
  {
    id: 12,
    title: '网约车平台大数据杀熟被实锤：老用户比新用户贵30%',
    slug: 'ride-hailing-big-data-price-discrimination',
    excerpt: '一项由消费者权益组织发起的调查发现，多家主流网约车平台存在明显的大数据杀熟行为，老用户的打车价格普遍比新用户高出20%-30%。',
    content: `一项由消费者权益组织发起的调查发现，多家主流网约车平台存在明显的大数据杀熟行为，老用户的打车价格普遍比新用户高出20%-30%。

调查团队使用多部手机在同一时间、同一地点进行打车测试。结果显示，高频使用平台的老用户账号，显示的预估价格明显高于几乎不使用的新账号。差价最高的案例中，老用户比新用户贵了整整32%。

更令人震惊的是，即使在非高峰时段，这种价格差异依然存在。技术人员分析认为，平台的算法会根据用户的使用频率、消费习惯甚至手机型号来动态调整价格。

此调查结果公布后，引发社会广泛关注。市场监管总局表示，将约谈相关平台企业，并对大数据杀熟行为进行专项整治。如查实存在违法行为，将依法从严处罚。

网友纷纷表示"早已有感觉，终于实锤了"，并呼吁平台方公开算法逻辑，接受社会监督。`,
    category: 'society',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20ride-hailing%20app%20with%20inflated%20pricing%20in%20a%20modern%20city%20streetscape%20at%20dusk%2C%20dramatic%20contrast%20between%20the%20bright%20screen%20and%20darkening%20urban%20environment%2C%20documentary%20street%20photography%20style%2C%20neon%20reflections%20on%20wet%20pavement%2C%20contemporary%20social%20commentary%20aesthetic&width=600&height=400&seq=article-card-12&orientation=landscape',
    heroImageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20ride-hailing%20app%20with%20inflated%20pricing%20in%20a%20modern%20city%20streetscape%20at%20dusk%2C%20dramatic%20contrast%20between%20the%20bright%20screen%20and%20darkening%20urban%20environment%2C%20documentary%20street%20photography%20style%2C%20neon%20reflections%20on%20wet%20pavement%2C%20contemporary%20social%20commentary%20aesthetic&width=800&height=450&seq=hero-side-12&orientation=landscape',
    date: '2026-07-25',
    views: 134560,
    tags: ['大数据杀熟', '网约车', '价格歧视', '消费者权益'],
    isHot: false,
    isTop: false,
  },
];

export const siteInfo = {
  name: '黑料91',
  tagline: '全网最新黑料曝光合集',
  description: '黑料91汇聚全网最劲爆黑料资讯，第一时间曝光明星、网红、大V的隐秘内幕，独家爆料不删档，每日更新海量黑料91内容，真实可信，让你一次看个够。',
  keywords: '黑料91,黑料91最新,黑料91爆料,黑料91不删版,黑料91合集,黑料91入口,黑料91网红内幕',
  domain: 'heiliao91.com',
  foundingDate: '2023-06-15',
  email: 'contact@heiliao91.com',
  phone: '400-888-9191',
  address: '广东省广州市天河区珠江新城华夏路91号',
  socialLinks: {
    weibo: 'https://weibo.com/heiliao91',
    wechat: 'heiliao91_official',
  },
};

export const aboutContent = {
  brandIntro: {
    title: '关于黑料91',
    paragraphs: [
      '黑料91成立于2023年，是国内领先的娱乐资讯与爆料聚合平台，致力于为广大网民提供最新、最全、最真实的内幕资讯。我们秉持"真实第一"的原则，坚持每一条爆料都经过严格核实，绝不传播虚假信息。',
      '平台汇聚了来自全国各地的优质内容创作者和线人网络，每日更新超过500条独家爆料内容，涵盖明星八卦、网红内幕、大V动态、社会热点等多个领域。我们的编辑团队7×24小时不间断工作，确保用户永远能在第一时间获取最新资讯。',
      '黑料91采用先进的AI+人工双重审核机制，在保证内容时效性的同时，严格把控内容质量。我们深知信息真实性的重要性，因此建立了业内最严格的事实核查流程，每一条发布的内容都经过三层交叉验证。',
    ],
  },
  reputation: {
    title: '平台口碑',
    items: [
      { label: '日均访问量', value: '500万+' },
      { label: '注册用户', value: '2000万+' },
      { label: '独家爆料', value: '10万+' },
      { label: '内容创作者', value: '5000+' },
    ],
    testimonials: [
      { content: '黑料91是我每天必刷的平台，爆料速度真的快，而且内容靠谱，不像其他平台那样全是标题党。', author: '资深网友 @娱乐圈观察者' },
      { content: '作为自媒体人，黑料91是我获取素材的重要渠道。他们的独家内容质量很高，经常能给我带来创作灵感。', author: '知名自媒体人 @娱乐大事件' },
      { content: '用了很多爆料平台，黑料91的体验是最好的。界面简洁，没有乱七八糟的广告，内容更新速度也很快。', author: '普通用户 @吃瓜群众小王' },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您有任何爆料线索、合作意向或意见建议，欢迎通过以下方式与我们取得联系。我们承诺对所有爆料人信息严格保密。',
    address: '广东省广州市天河区珠江新城华夏路91号 黑料91总部',
    email: 'contact@heiliao91.com',
    phone: '400-888-9191',
    workHours: '周一至周日 9:00 - 21:00',
  },
  faq: [
    { question: '黑料91的内容是否真实可靠？', answer: '黑料91拥有严格的审核机制，所有内容发布前均经过至少三层交叉验证。我们的编辑团队由资深媒体人组成，确保每一条爆料都有可靠的信息来源。同时，我们也会在内容中明确标注信息核实状态，让读者自行判断。' },
    { question: '如何向黑料91提供爆料线索？', answer: '您可以通过我们的官方邮箱 contact@heiliao91.com 发送爆料信息。我们承诺对所有爆料人的身份信息严格保密，并对于采用的重要线索给予相应的稿酬奖励。' },
    { question: '黑料91的内容会删档吗？', answer: '黑料91承诺内容不删档。我们坚持信息的完整性和可追溯性，所有已发布的内容均可在平台内检索查看。如因法律原因确实需要调整，我们会在原位置保留调整说明。' },
    { question: '如何申请成为黑料91的内容创作者？', answer: '我们欢迎所有热爱娱乐资讯创作的朋友加入。请将您的个人简介和代表作品发送至邮箱，我们的编辑团队会在3个工作日内审核并回复。' },
    { question: '黑料91的会员有什么特权？', answer: '黑料91会员可享受无广告浏览、抢先阅读独家爆料、参与线下活动等多项特权。我们定期为会员举办明星见面会、行业沙龙等专属活动。' },
  ],
};